module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table"
  }, [(_vm.view_mode.show_filters) ? _c('div', {
    staticClass: "table-actions"
  }, [_c('filters', {
    attrs: {
      "filters": _vm.filters,
      "show_user_filter": _vm.view_mode.user_filter,
      "show_tag_filter": _vm.view_mode.tags_filter,
      "show_lost_reason_filter": _vm.view_mode.lost_reason,
      "show_group_filter": _vm.view_mode.group_filter,
      "show_stage_filter": _vm.view_mode.stage,
      "show_status_filter": _vm.view_mode.status,
      "label_clear_filter": _vm.view_mode.label_clear_filter,
      "user_id": _vm.user_id
    },
    on: {
      "filter": _vm.filter
    }
  })], 1) : _vm._e(), (_vm.view_mode.show_selections) ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('mass-actions', {
    attrs: {
      "unselected_ids": _vm.unselected_contact_ids,
      "selected_ids": _vm.selected_contact_ids,
      "count_all_contacts": _vm.count_all_contacts,
      "count_page_contacts": _vm.count_page_contacts,
      "filters": _vm.filters
    },
    on: {
      "user-selected": _vm.bubbleUp
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "table-header table-row"
  }, [(_vm.view_mode.show_checkbox && !_vm.view_mode.show_selections) ? _c('div', {
    staticClass: "table-col contact-list-item-select table-col-collapsed"
  }, [_c('div', {
    staticClass: "checkbox-inline contact-list-item-checkbox-item",
    attrs: {
      "id": "contact-select-all-checkbox"
    },
    on: {
      "click": function($event) {
        return _vm.toggleSelectAll()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.selected_all
    }
  }), _c('label', [_vm._v(" ")])])]) : (_vm.view_mode.show_selections) ? _c('div', {
    staticClass: "table-col contact-list-item-select table-col-collapsed gap"
  }, [_c('label', [_vm._v("   ")])]) : _vm._e(), _c('div', {
    staticClass: "table-col table-col-empashis table-col-120 contact-list-item-name"
  }, [_vm._v(_vm._s(_vm.$t('contacts.title.singular')))]), (_vm.view_mode.show_created_at_column) ? _c('div', {
    staticClass: "table-col table-col-50 contact-list-item-status-updated-at"
  }, [_vm._v("Data")]) : _vm._e(), (_vm.view_mode.business == "column") ? _c('div', {
    staticClass: "table-col contact-list-item-business"
  }, [_vm._v(_vm._s(_vm.$t('users.attributes.company')))]) : _vm._e(), (_vm.view_mode.flow) ? _c('div', {
    staticClass: "table-col contact-list-item-flow"
  }, [_vm._v("Fluxo")]) : _vm._e(), (_vm.view_mode.action_step) ? _c('div', {
    staticClass: "table-col contact-list-item-action-step"
  }, [_vm._v("Etapa no Fluxo")]) : _vm._e(), (_vm.view_mode.show_status_updated_at_column) ? _c('div', {
    staticClass: "table-col contact-list-item-status-updated-at"
  }, [_vm._v("Data da pausa")]) : _vm._e(), (_vm.view_mode.show_stage_updated_at_column) ? _c('div', {
    staticClass: "table-col contact-list-item-status-updated-at"
  }, [_vm._v("Data e Hora")]) : _vm._e(), (_vm.view_mode.status) ? _c('div', {
    staticClass: "table-col contact-list-item-status"
  }, [_vm._v(_vm._s(_vm.$t('users.attributes.status')))]) : _vm._e(), (_vm.view_mode.stage) ? _c('div', {
    staticClass: "table-col contact-list-item-stage"
  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.stage')))]) : _vm._e(), (_vm.view_mode.group) ? _c('div', {
    staticClass: "table-col contact-list-item-group"
  }, [_vm._v(_vm._s(_vm.$t('groups.label.group')))]) : _vm._e(), (_vm.view_mode.user && !_vm.view_mode.only_picture_miniature) ? _c('div', {
    staticClass: "table-col contact-list-item-user"
  }, [_vm._v("Responsável")]) : _vm._e(), (_vm.view_mode.user && _vm.view_mode.only_picture_miniature) ? _c('div', {
    staticClass: "table-col table-col-30"
  }, [_vm._v("Resp.")]) : _vm._e(), (_vm.view_mode.initialized_contact_icon) ? _c('div', {
    staticClass: "table-col contact-list-item-actions table-col-collapsed"
  }) : _vm._e(), (_vm.view_mode.edit_button) ? _c('div', {
    staticClass: "table-col contact-list-item-actions table-col-collapsed"
  }) : _vm._e(), (_vm.view_mode.delete_button) ? _c('div', {
    staticClass: "table-col contact-list-item-actions table-col-collapsed"
  }) : _vm._e(), (_vm.add_action_column) ? _c('div', {
    staticClass: "table-col contact-list-item-actions table-col-collapsed"
  }) : _vm._e()]), _c('div', {
    staticClass: "table-body",
    class: {
      'internal-scroller': _vm.internal_scroller
    }
  }, [_c('draggable', {
    attrs: {
      "value": _vm.contacts,
      "options": _vm.draggable_options
    },
    on: {
      "input": _vm.priorityUpdated
    }
  }, _vm._l((_vm.contacts), function(contact) {
    return _c('contact-list-item', {
      key: contact.guid,
      attrs: {
        "contact": contact,
        "view_mode": _vm.view_mode,
        "flow": _vm.flow,
        "initially_selected": _vm.isInitiallySelected(contact),
        "origem": _vm.origem
      },
      on: {
        "contact-destroy": _vm.bubbleUp,
        "reengage-contact": _vm.bubbleUp,
        "contact-update": _vm.bubbleUp,
        "contact-recipient-update": _vm.bubbleUp,
        "contact-recipient-reset": _vm.bubbleUp,
        "contact-selected": _vm.bubbleUp,
        "contact-edit": _vm.bubbleUp,
        "toggle-task-bar": _vm.bubbleUp,
        "contact-removed-from-flow": _vm.removeContactFromList
      }
    }, [_vm._t("default", null, {
      "contact": contact
    })], 2)
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16ffd404!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/list.vue
// module id = 1027
// module chunks = 1